import type { Notification } from "@inloco/shared";
import { Icon } from "./Icon";

export interface NotificationProps {
    notification: Notification,
    onDismiss: (id: string) => void
}

export default function NotificationComp({ notification, onDismiss }: NotificationProps) {
    const { id, message, type } = notification;

    const getAlertClass = () => {
        switch (type) {
            case 'success':
                return 'alert-success';
            case 'warning':
                return 'alert-warning';
            case 'error':
                return 'alert-error';
            case 'info':
            default:
                return 'alert-info';
        }
    };

    const getIcon = () => {
        switch (type) {
            case 'success':
                return (<Icon name="check_circle" className="text-2xl leading-none" />);
            case 'warning':
                return (<Icon name="warning" className="text-2xl leading-none" />);
            case 'error':
                return (<Icon name="error" className="text-2xl leading-none" />);
            case 'info':
            default:
                return (<Icon name="info" className="text-2xl leading-none" />);
        }
    };

    return (
        <div className={`alert ${getAlertClass()} shadow-lg`} role="alert">
            {getIcon()}
            <span>{message}</span>
            {notification.closable && (
                <button
                    className="btn btn-xs btn-circle btn-ghost"
                    onClick={() => onDismiss(id)}>✕</button>
            )}
        </div>
    );
};